export const tools = [
  {
    engHref: 'https://nakdan.dicta.org.il/?lang=en',
    hebHref: 'https://nakdan.dicta.org.il/',
    logo: require('../../assets/menu-icons/Logo Nakdan_Blue_Circle.png'),
    engTitle: 'Nakdan',
    engSubtitle: 'Add nikud to modern / rabbinic / poetic text',
    hebTitle: 'נקדן אוטומטי',
    hebSubtitle: 'ניקוד טקסט מודרני / רבני / שירה'
  },
  {
    href: 'https://tiberias.dicta.org.il',
    logo: require('../../assets/menu-icons/Logo Classify_Blue_Circle.png'),
    engTitle: 'Tiberias: Bible Classification',
    engSubtitle: 'Categorize text using stylistic markers',
    hebTitle: 'סיווג טקסטים',
    hebSubtitle: 'השוואת טקסטים בהתבסס על מאפיינים סיגנוניים'
  },
  {
    engHref: 'https://synoptic.dicta.org.il/?lang=en',
    hebHref: 'https://synoptic.dicta.org.il/',
    logo: require('../../assets/menu-icons/Logo Synoptic_Blue_Circle.png'),
    engTitle: 'Synopsis Builder',
    engSubtitle: 'Align alternate versions of a text',
    hebTitle: 'השוואת גרסאות',
    hebSubtitle: 'השוואה בין גרסאות של טקסט'
  },
  {
    href: 'https://nakdanpro.dicta.org.il/',
    logo: require('../../assets/menu-icons/Logo Nakdan_Blue_Circle.png'),
    engTitle: 'Nakdan Pro',
    engSubtitle: 'Enhanced Nakdan interface for efficient nikud',
    hebTitle: 'נקדן מקצועי',
    hebSubtitle: 'נקדן עם ממשק מותאם לאנשי מקצוע'
  },
  {
    engHref: 'https://citation.dicta.org.il/?lang=en',
    hebHref: 'https://citation.dicta.org.il/',
    logo: require('../../assets/menu-icons/Logo Pasuk Finder_Blue_Circle.png'),
    engTitle: 'Citation Finder',
    engSubtitle: 'Find biblical and talmudic citations',
    hebTitle: 'איתור אזכורים',
    hebSubtitle: 'איתור אזכורים תנ״כיים ותלמודיים בכל טקסט'
  },
  {
    engHref: 'https://search.dicta.org.il/?lang=en',
    hebHref: 'https://search.dicta.org.il/',
    logo: require('../../assets/menu-icons/Logo Search_Blue_Circle.png'),
    engTitle: 'Search the Bible',
    engSubtitle: 'Find what you\'re really looking for in the Bible',
    hebTitle: 'חיפוש בתנ״ך',
    hebSubtitle: 'מנוע חיפוש אינטואיטיבי לתנ״ך'
  },
  {
    engHref: 'https://segment.dicta.org.il/?lang=en',
    hebHref: 'https://segment.dicta.org.il/',
    logo: require('../../assets/menu-icons/Logo Segmentation_Blue_Circle.png'),
    engTitle: 'Stylistic Segmentation',
    engSubtitle: 'Partition text using stylistic markers',
    hebTitle: 'פילוח סגנוני',
    hebSubtitle: 'חלוקת טקסט לפי מאפיינים סגנוניים'
  },
  {
    href: 'http://abbreviation.dicta.org.il/',
    logo: require('../../assets/menu-icons/Logo Acronyms_Blue_Circle.png'),
    engTitle: 'Abbreviation Expander',
    engSubtitle: 'Context aware expansion of abbreviation',
    hebTitle: 'פיענוח ראשי תיבות',
    hebSubtitle: 'זיהוי ופיענוח ראשי תיבות בטקסטים רבניים'
  },
  {
    engHref: 'https://talmudsearch.dicta.org.il/?lang=en',
    hebHref: 'https://talmudsearch.dicta.org.il/',
    logo: require('../../assets/menu-icons/Logo Search_Talmud_Blue_Circle.png'),
    engTitle: 'Search the Talmud',
    engSubtitle: 'Find what you\'re really looking for in the Talmud',
    hebTitle: 'חיפוש בתלמוד',
    hebSubtitle: 'מנוע חיפוש אינטואיטיבי לתלמוד'
  },
  {
    href: 'http://wordplay.dicta.org.il/',
    logo: require('../../assets/menu-icons/Logo Charuzit_Blue_Circle.png'),
    engTitle: 'Charuzit - Beta version',
    engSubtitle: 'Find rhymes, assonance, and alliteration',
    hebTitle: 'חרוזית - גירסת בטא',
    hebSubtitle: 'איתור חרוזים, מצלול ואליטרציה'
  }]
